import { Routes } from '@angular/router';
import { AuthGuard } from './core/services/auth-guard.service';
import { CompanyAuthGuard } from './core/services/company-auth-guard.service';
import { AdminLayoutComponent } from './shared/components/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';

export const rootRouterConfig: Routes = [


  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./modules/arc-admin/sessions/sessions.module').then(m => m.SessionsModule),
        data: { title: 'Session' }
      },

      {
        path: 'company',
        loadChildren: () => import('./modules/company/sessions/sessions.module').then(m => m.SessionsModule),
        data: { title: 'Session' }
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/arc-admin/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: { title: 'Dashboard', breadcrumb: 'DASHBOARD' }
      },
      {
        path: 'customer',
        loadChildren: () => import('./modules/arc-admin/customer/customer.module').then(m => m.AppCustomerModule),
        data: { title: 'Customer', breadcrumb: 'Customer' }
      },
      {
        path: 'employee',
        loadChildren: () => import('./modules/arc-admin/employee/employee.module').then(m => m.AppEmployeeModule),
        data: { title: 'Employee', breadcrumb: 'Employee' }
      },
      {
        path: 'campaigns',
        loadChildren: () => import('./modules/arc-admin/campaigns/campaigns.module').then(m => m.AppCampaignsModule),
        data: { title: 'Campaigns', breadcrumb: 'Campaigns' }
      },
      {
        path: 'reports',
        loadChildren: () => import('./modules/arc-admin/reports/reports.module').then(m => m.AppReportsModule),
        data: { title: 'Reports', breadcrumb: 'Reports' }
      },
      {
        path: 'settings',
        loadChildren: () => import('./modules/arc-admin/settings/settings.module').then(m => m.AppSettingsModule),
        data: { title: 'Settings', breadcrumb: 'Settings' }
      },

    ]
  },

  {
    path: 'company',
    component: AdminLayoutComponent,
    canActivate: [CompanyAuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/company/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: { title: 'Dashboard', breadcrumb: 'DASHBOARD' }
      },
      {
        path: 'customer',
        loadChildren: () => import('./modules/company/customer/customer.module').then(m => m.AppCustomerModule),
        data: { title: 'Customer', breadcrumb: 'Customer' }
      },
      {
        path: 'employee',
        loadChildren: () => import('./modules/company/employee/employee.module').then(m => m.AppEmployeeModule),
        data: { title: 'Employee', breadcrumb: 'Employee' }
      },
      {
        path: 'campaigns',
        loadChildren: () => import('./modules/company/campaigns/campaigns.module').then(m => m.AppCampaignsModule),
        data: { title: 'Campaigns', breadcrumb: 'Campaigns' }
      },
      {
        path: 'reports',
        loadChildren: () => import('./modules/company/reports/reports.module').then(m => m.AppReportsModule),
        data: { title: 'Reports', breadcrumb: 'Reports' }
      },    

      {
        path: 'settings',
        loadChildren: () => import('./modules/company/settings/settings.module').then(m => m.AppSettingsModule),
        data: { title: 'Settings', breadcrumb: 'Settings' }
      },
    ]
  },
  {
    path: '**',
    redirectTo: 'sessions/404'
  }
];

